var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConfirmIcon = function SvgConfirmIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM11.7071 15.2071L16.7071 10.2071L15.2928 8.79285L11 13.0857L8.20706 10.2928L6.79285 11.7071L10.2928 15.2071C10.6834 15.5976 11.3165 15.5976 11.7071 15.2071Z",
    fill: "white"
  })));
};
export { SvgConfirmIcon as ReactComponent };
export default __webpack_public_path__ + "assets/11e65595.svg";